import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AccountType } from "../../types/genericType";

const initialAccountState: AccountType = {
  id: 0,
  investor: 0,
  name: "",
  report1099Name: "",
  accountNumber: "",
  rate: 0,
  balance: 0,
  startDate: "",
  endDate: "",
  accountType: "",
  interestType: "",
  isActive: false,
  investorName: "",
};

interface AccountsState {
  selectedAccount: AccountType;
}

const initialState: AccountsState = {
  selectedAccount: initialAccountState,
};

export const accountsSlice = createSlice({
  name: "accountsState",
  initialState,
  reducers: {
    setSelectedAccount: (state, action: PayloadAction<AccountType>) => {
      state.selectedAccount = action.payload;
    },
    resetSelectedAccount: (state) => {
      state.selectedAccount = initialAccountState;
    },
  },
});

export const { setSelectedAccount, resetSelectedAccount } =
  accountsSlice.actions;

export default accountsSlice.reducer;
